import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ErrorLevel, TagStringValueDto, WidgetClass, WidgetValues } from '../../../models';
import { TableWidget } from '../../../widgets/widgets.index';
import {
    IDashboardLoadService,
    IDateRangeService,
    ISeriesService,
    IStringValuesService,
    ITableWidgetService,
    IwidgetIntervalHelperService
} from '../../../services';
import { missingSeries } from '../../../common/constants';
import { refreshClick } from '../../../common/events';
import { WideError } from '../../../common/WideError';
import { getError, getWidgetClass, } from '../../../common/helpers';
import { RowViewModel } from '../../../widgets';

class DynamicTableController implements angular.IComponentController {
    data: WidgetValues;
    widgetsResults: WidgetValues[];
    isLoading: boolean;
    item: TableWidget;
    loadingMessage: string;
    rowViewModels: RowViewModel[];
    stringValues: TagStringValueDto[];

    static $inject = [
        '$scope',
        '$q',
        'dashboardLoadService',
        'dateRangeService',
        'widgetIntervalHelperService',
        'stringValuesService',
        'seriesService',
        'tableWidgetService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$q: angular.IQService,
        private _dashboardLoadService: IDashboardLoadService,
        private _dateRangeService: IDateRangeService,
        private _widgetIntervalService: IwidgetIntervalHelperService,
        private _stringValuesService: IStringValuesService,
        private _seriesService: ISeriesService,
        private _tableWidgetService: ITableWidgetService
    ) {
    }

    $onInit() {
        this.data = {} as WidgetValues;
        const item = new TableWidget(this._$q, this._dateRangeService, this._widgetIntervalService);
        item.name = 'Table';
        item.configuration.dateFormat = 'yyyy-MM-DD HH:mm';
        item.configuration.maxColumns = 1000;
        this.item = item;

        this._$scope.$watch(() => this.item.configuration.rows, () => {
            this.refresh(this._dateRangeService.beginDate(), this._dateRangeService.endDate(), false);
        }, true);

        this._$scope.$on(refreshClick, (event, data) => {
            this.refresh(data.beginDate, data.endDate, data.force);
        });
    }

    getError(): WideError {
        return getError(this.item);
    }

    getWidgetClass(): WidgetClass {
        return getWidgetClass(this.item);
    }

    private refresh(beginDate: any, endDate: any, force: boolean) {
        if (this.item && beginDate && endDate) {
            this.loadingMessage = 'Loading data';
            this.isLoading = true;
            return this._dashboardLoadService
                .refresh([this.item], beginDate, endDate, null, null, null, force)
                .then(widgetResults => {
                    this.widgetsResults = widgetResults;
                    return this._stringValuesService.getAll();
                })
                .then(stringValues => {
                    this.stringValues = stringValues;
                    return this._seriesService.getUpdatedGuids(this.item.configuration.rows);
                })
                .then(seriesGuidList => this._tableWidgetService.getRowViewModels(seriesGuidList))
                .then(rowViewModels => {
                    if (_.some(rowViewModels, c => !c.name)) {
                        this.item.setError(new WideError(ErrorLevel.Error, missingSeries));
                    }
                    this.rowViewModels = rowViewModels;
                    this.data = this.widgetsResults[0];
                })
                .catch(e => console.log(e))
                .finally(() => this.isLoading = false);
        } else {
            return this._$q.when(undefined);
        }
    }
}

export const wtDynamicTable: ComponentDefinition = {
    componentId: 'wtDynamicTable',
    controller: DynamicTableController,
    template: require('./dynamicTable.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};